<template>
    <div class="page-component-loading">
        <div class="figure-loading"></div>
    </div>
</template>
<script>
export default {
    name: 'PageLoading'
};
</script>
<style lang="less" scoped>
.page-component-loading {
    position: fixed;
    z-index: 200;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -160px;

    .figure-loading {
        position: relative;
        width: 56px;
        height: 56px;
        background: url('https://i.gsxcdn.com/1794235023_k3r2x7x6.gif') no-repeat;
        background-size: cover;
    }
}
</style>
